import { render, staticRenderFns } from "./cg-event-teaser.vue?vue&type=template&id=34efa07a&scoped=true"
import script from "./cg-event-teaser.vue?vue&type=script&lang=js"
export * from "./cg-event-teaser.vue?vue&type=script&lang=js"
import style0 from "./cg-event-teaser.vue?vue&type=style&index=0&id=34efa07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34efa07a",
  null
  
)

export default component.exports